import {
  red,
  pink,
  purple,
  deepPurple,
  indigo,
  blue,
  lightBlue,
  cyan,
  teal,
  green,
  lightGreen,
  lime,
  yellow,
  amber,
  orange,
  deepOrange,
  grey,
} from '@mui/material/colors';

export const getColor = (color: string) => {
  switch (color) {
    case 'red':
      return red;
    case 'pink':
      return pink;
    case 'purple':
      return purple;
    case 'deepPurple':
      return deepPurple;
    case 'indigo':
      return indigo;
    case 'blue':
      return blue;
    case 'lightBlue':
      return lightBlue;
    case 'cyan':
      return cyan;
    case 'teal':
      return teal;
    case 'green':
      return green;
    case 'lightGreen':
      return lightGreen;
    case 'lime':
      return lime;
    case 'yellow':
      return yellow;
    case 'amber':
      return amber;
    case 'orange':
      return orange;
    case 'deepOrange':
      return deepOrange;

    default:
      return grey;
  }
};

export const availableHues = [
  { name: 'red', hue: red },
  { name: 'pink', hue: pink },
  { name: 'purple', hue: purple },
  { name: 'deepPurple', hue: deepPurple },
  { name: 'indigo', hue: indigo },
  { name: 'blue', hue: blue },
  { name: 'lightBlue', hue: lightBlue },
  { name: 'cyan', hue: cyan },
  { name: 'teal', hue: teal },
  { name: 'green', hue: green },
  { name: 'lightGreen', hue: lightGreen },
  { name: 'lime', hue: lime },
  { name: 'yellow', hue: yellow },
  { name: 'amber', hue: amber },
  { name: 'orange', hue: orange },
  { name: 'deepOrange', hue: deepOrange },
];
